import { gql, type TypedDocumentNode } from '@apollo/client';
import {
	type CreateImageSearchFromUrlMutationMutation,
	type CreateImageSearchFromUrlMutationMutationVariables,
} from '@apps/www/src/__generated__/graphql';

const CreateImageSearchFromURLMutation: TypedDocumentNode<
	CreateImageSearchFromUrlMutationMutation,
	CreateImageSearchFromUrlMutationMutationVariables
> = gql`
	mutation CreateImageSearchFromURLMutation($input: CreateImageSearchFromURLInput!) {
		createImageSearchFromURL(input: $input) {
			_id
			shortID
			imageURL
			colors {
				color
				amount
			}
		}
	}
`;

export default CreateImageSearchFromURLMutation;
